"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M4.8 6.503a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m2.7-1.25a.5.5 0 0 0 0 1H19a.5.5 0 0 0 0-1zm0 6.247a.5.5 0 0 0 0 1H19a.5.5 0 1 0 0-1zM7 18.25a.5.5 0 0 1 .5-.5H19a.5.5 0 0 1 0 1H7.5a.5.5 0 0 1-.5-.5M5.55 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.75 7a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
}), 'List');
